import { useAuth } from "../../auth/AuthProvider";
import { useNavigate } from "react-router-dom";

interface FlightBookingButtonProps {
  packageId: number;
}

const FlightBookingButton: React.FC<FlightBookingButtonProps> = ({ packageId }) => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();

  const handleBookNow = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (!isLoggedIn) {
      // Se não estiver logado, abrir modal de registro/login
      const modal = document.getElementById("register-modal");
      if (modal) {
        const bootstrapModal = new (window as any).bootstrap.Modal(modal);
        bootstrapModal.show();
      }
      return;
    }

    // Se estiver logado, redireciona para a tela de booking do pacote
    navigate(`/flight/flight-booking/${packageId}`);
  };

  return (
    <div className="banner-form">
      <form className="form-info border-0">
        <button
          type="submit"
          className="btn btn-primary btn-lg search-btn ms-0 w-100 mb-3 fs-14 justify-content-center"
          onClick={handleBookNow}
        >
          Book Now
        </button>
      </form>
    </div>
  );
};

export default FlightBookingButton;
